module.exports = __webpack_public_path__ + "static/media/CICLO_6_PAZ_Y_COMUNIDAD_DIGITAL_2022.1afd311c.jpg";